import {lazy} from 'react'
import * as routes from '../routes'
import {PERMISSION_ROLES, PERMISSION_ID} from 'constants'
import {SURVEYS_EDIT} from '../routes'

const ProfileComponent = lazy(() => import('views/profile'))
const DashboardComponent = lazy(() => import('views/dashboard'))
const OccupantsComponent = lazy(() => import('views/users/occupants/list'))
const OccupantsFormComponent = lazy(() => import('views/users/occupants/form'))
const PendingOccupantsComponent = lazy(() => import('views/users/occupants/pendingList'))
const GuardsComponent = lazy(() => import('views/users/guards/list'))
const GuardsFormComponent = lazy(() => import('views/users/guards/form'))
const AdminsComponent = lazy(() => import('views/users/admins/list'))
const AdminsFormComponent = lazy(() => import('views/users/admins/form'))
const TechniciansComponent = lazy(() => import('views/users/technicians/list'))
const TechniciansFormComponent = lazy(() => import('views/users/technicians/form'))
const VendorAdminFormComponent = lazy(() => import('views/users/vendors/form'))
const VendorAdminList = lazy(() => import('views/users/vendors/list'))
const SocietyStructureUploadComponent = lazy(() => import('views/societyStructure/upload'))
const PropertiesComponent = lazy(() => import('views/societyStructure/properties'))
const SocietiesComponent = lazy(() => import('views/societies/list'))
const SocietyFormComponent = lazy(() => import('views/societies/form'))
const AnnouncementsComponent = lazy(() => import('views/announcements/list'))
const AnnouncementFormComponent = lazy(() => import('views/announcements/form'))
const VisitorLogsComponent = lazy(() => import('views/visitors/logsList'))
const VisitorsQRComponent = lazy(() => import('views/visitors/qrAppliedList'))
const InvoicesComponent = lazy(() => import('views/invoices/list'))
const InvoiceFormComponent = lazy(() => import('views/invoices/form'))
const ComplaintsComponent = lazy(() => import('views/complaints/list'))
const ComplaintFormComponent = lazy(() => import('views/complaints/form'))
const AdsComponent = lazy(() => import('views/ads/list'))
const AdFormComponent = lazy(() => import('views/ads/form'))
const EmailsComponent = lazy(() => import('views/emails/list'))
const PushNotificationsComponent = lazy(() => import('views/pushNotifications/list'))
const BrandAdsComponent = lazy(() => import('views/brandAds/list'))
const BrandAdsFormComponent = lazy(() => import('views/brandAds/form'))
const BrandComponent = lazy(() => import('views/brands/list'))
const BrandFormComponent = lazy(() => import('views/brands/form'))
const CreateSurveyComponent = lazy(() => import('views/surveys/form'))
const SurveyListComponent = lazy(() => import('views/surveys/list'))
const SurveyAnswerListComponent = lazy(() => import('views/surveys/answerList'))
const SurveyViewComponent = lazy(() => import('views/surveys/view'))
const TicketFormComponent = lazy(() => import('views/tickets/form'))
const TicketsList = lazy(() => import('views/tickets/list'))
const ServiceCategoryFormComponent = lazy(() => import('views/ServiceCategories/form'))
const ServiceCategoryList = lazy(() => import('views/ServiceCategories/list'))
const ServiceFormComponent = lazy(() => import('views/services/form'))
const ServiceList = lazy(() => import('views/services/list'))
const ServicesOccupantsList = lazy(() => import('views/services/ServicesOccupantsList'))
const BookingFormComponent = lazy(() => import('views/booking/form'))
const BookingList = lazy(() => import('views/booking/list'))
const PanicQueriesList = lazy(() => import('views/panicQueries/list'))

// const BrandsAdsComponent = lazy(() => import('views/brandsAds/list'))
// const BrandsAdsFormComponent = lazy(() => import('views/brandsAds/form'))

const privateRoutes = [
  {
    path: routes.PROFILE,
    title: 'Profile',
    component: ProfileComponent,
  },
  {
    path: routes.DASHBOARD,
    title: 'Dashboard',
    component: DashboardComponent,
    permission: [PERMISSION_ROLES.superAdmin, PERMISSION_ROLES.societyAdmin],
  },

  // Occupants
  {
    path: routes.OCCUPANTS_LIST,
    title: 'Occupants List',
    component: OccupantsComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },
  {
    path: routes.OCCUPANTS_CREATE,
    title: 'Create Occupant',
    component: OccupantsFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },
  {
    path: routes.OCCUPANTS_EDIT,
    title: 'Update Occupant',
    component: OccupantsFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },
  {
    path: routes.PENDING_OCCUPANTS_LIST,
    title: 'Pending Occupants',
    component: PendingOccupantsComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },
  {
    path: routes.OCCUPANTS_VIEW,
    title: 'View Occupant',
    component: OccupantsFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },

  // Guards
  {
    path: routes.GUARDS_LIST,
    title: 'Guards List',
    component: GuardsComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },
  {
    path: routes.GUARDS_CREATE,
    title: 'Create Guard',
    component: GuardsFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },
  {
    path: routes.GUARDS_EDIT,
    title: 'Update Guard',
    component: GuardsFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },

  // Admins
  {
    path: routes.ADMINS_LIST,
    title: 'Admins List',
    component: AdminsComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },
  {
    path: routes.ADMINS_CREATE,
    title: 'Create Admin',
    component: AdminsFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },
  {
    path: routes.ADMINS_EDIT,
    title: 'Update Admin',
    component: AdminsFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },

  // Technicians
  {
    path: routes.TECHNICIANS_LIST,
    title: 'Technicians List',
    component: TechniciansComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },
  {
    path: routes.TECHNICIANS_CREATE,
    title: 'Create Technician',
    component: TechniciansFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },
  {
    path: routes.TECHNICIANS_EDIT,
    title: 'Update Technician',
    component: TechniciansFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },

  // Vendor Admin
  {
    path: routes.VENDORS_LIST,
    title: 'Vendors List',
    component: VendorAdminList,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.vendor,
  },
  {
    path: routes.CREATE_VENDORS,
    title: 'Create Vendor',
    component: VendorAdminFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.vendor,
  },
  {
    path: routes.EDIT_VENDORS,
    title: 'Update Vendor',
    component: VendorAdminFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.vendor,
  },
  // Visitors
  {
    path: routes.VISITORS_QR_CODE,
    title: 'QR Applied List',
    component: VisitorsQRComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.users,
  },

  // society Structure
  {
    path: routes.SOCIETY_STRUCTURE_UPLOAD,
    title: 'Upload Society Structure',
    component: SocietyStructureUploadComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.societies,
  },
  {
    path: routes.SOCIETY_STRUCTURE_PROPERTIES,
    title: 'Properties List',
    component: PropertiesComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.societies,
  },

  // Societies
  {
    path: routes.SOCIETIES_LIST,
    title: 'Societies List',
    component: SocietiesComponent,
    permission: [PERMISSION_ROLES.superAdmin],
  },
  {
    path: routes.SOCIETIES_CREATE,
    title: 'Create Society',
    component: SocietyFormComponent,
    permission: [PERMISSION_ROLES.superAdmin],
  },
  {
    path: routes.SOCIETIES_EDIT,
    title: 'Update Society',
    component: SocietyFormComponent,
    permission: [PERMISSION_ROLES.superAdmin],
  },

  // Brand Ads

  {
    path: routes.BRANDS_ADS_LIST,
    title: 'Brand Ads List',
    component: BrandAdsComponent,
    permission: [PERMISSION_ROLES.superAdmin],
  },
  {
    path: routes.BRANDS_ADS__CREATE,
    title: 'Create Brand Ads',
    component: BrandAdsFormComponent,
    permission: [PERMISSION_ROLES.superAdmin],
  },
  {
    path: routes.BRANDS_ADS__EDIT,
    title: 'Update Brand Ads',
    component: BrandAdsFormComponent,
    permission: [PERMISSION_ROLES.superAdmin],
  },

  // Announcements
  {
    path: routes.ANNOUNCEMENTS_LIST,
    title: 'Announcements List',
    component: AnnouncementsComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.announcements,
  },
  {
    path: routes.ANNOUNCEMENTS_CREATE,
    title: 'Create Announcement',
    component: AnnouncementFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.announcements,
  },
  {
    path: routes.ANNOUNCEMENTS_EDIT,
    title: 'Update Announcement',
    component: AnnouncementFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.announcements,
  },

  // Entry/exit logs
  {
    path: routes.ENTRY_EXIT_LOGS_LIST,
    title: 'Entry / Exit List',
    component: VisitorLogsComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.logs,
  },

  // Invoices
  {
    path: routes.INVOICES_LIST,
    title: 'Invoices List',
    component: InvoicesComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.invoices,
  },
  {
    path: routes.INVOICES_CREATE,
    title: 'Create Invoice',
    component: InvoiceFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.invoices,
  },
  {
    path: routes.INVOICES_EDIT,
    title: 'Update Invoice',
    component: InvoiceFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.invoices,
  },

  // Complaints
  {
    path: routes.COMPLAINTS_LIST,
    title: 'Complaints List',
    component: ComplaintsComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.technicians],
    screen_id: PERMISSION_ID.complaints,
  },
  // {
  //   path: routes.COMPLAINTS_CREATE,
  //   title: 'Create Complaint',
  //   component: ComplaintFormComponent,
  //   permission: [PERMISSION_ROLES.societyAdmin],
  //   screen_id: PERMISSION_ID.complaints,
  // },
  {
    path: routes.COMPLAINTS_EDIT,
    title: 'Update Complaint',
    component: ComplaintFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.technicians],
    screen_id: PERMISSION_ID.complaints,
  },

  // Ads
  {
    path: routes.ADS_LIST,
    title: 'Ads List',
    component: AdsComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.ads,
  },
  {
    path: routes.ADS_CREATE,
    title: 'Create Ad',
    component: AdFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.ads,
  },
  {
    path: routes.ADS_EDIT,
    title: 'Update Ad',
    component: AdFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.ads,
  },

  // Emails
  {
    path: routes.EMAILS_LIST,
    title: 'Emails List',
    component: EmailsComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.emails,
  },

  // Push Notifications
  {
    path: routes.PUSH_NOTIFICATIONS_LIST,
    title: 'Push Notifications List',
    component: PushNotificationsComponent,
    permission: [PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.pushNotifications,
  },

  // Surveys

  {
    path: routes.SURVEYS_CREATE,
    title: 'Create Survey',
    component: CreateSurveyComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.survey,
  },
  {
    path: routes.SURVEYS_LIST,
    title: 'Survey List',
    component: SurveyListComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.survey,
  },
  {
    path: routes.SURVEYS_ANSWER_BASE,
    title: 'Survey Answers',
    component: SurveyAnswerListComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.survey,
  },
  {
    path: routes.SURVEYS_EDIT,
    title: 'Update Survey',
    component: CreateSurveyComponent, // Assuming the form component is CreateSurveyComponent
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.survey,
  },

  {
    path: routes.SURVEYS_VIEW,
    title: 'View Survey',
    component: SurveyViewComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.survey,
  },

  // Brands Ads
  {
    path: routes.BRANDADS_LIST,
    title: 'Brands List',
    component: BrandAdsComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.brandsAds,
  },
  {
    path: routes.BRANDADS_CREATE,
    title: 'Create Brands',
    component: BrandAdsFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.brandsAds,
  },
  {
    path: routes.BRANDADS_EDIT,
    title: 'Update Brand',
    component: BrandAdsFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.brandsAds,
  },

  //brands
  {
    path: routes.BRANDS_LIST,
    title: 'Brand Ads List',
    component: BrandComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.brands,
  },
  {
    path: routes.BRANDS_CREATE,
    title: 'Create Brand Ad',
    component: BrandFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.brands,
  },
  {
    path: routes.BRAND_EDIT,
    title: 'Update Brand',
    component: BrandFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.brands,
  },

  //ticket
  {
    path: routes.TICKETS_LIST,
    title: 'Tickets List',
    component: TicketsList,
    permission: [PERMISSION_ROLES.superAdmin, PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.tickets,
  },
  {
    path: routes.TICKETS_CREATE,
    title: 'Create Ticket',
    component: TicketFormComponent,
    permission: [PERMISSION_ROLES.superAdmin, PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.tickets,
  },
  {
    path: routes.TICKETS_EDIT,
    title: 'Update Ticket',
    component: TicketFormComponent,
    permission: [PERMISSION_ROLES.superAdmin, PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.tickets,
  },

  // ServiceCategory
  {
    path: routes.SERVICE_CATEGORY_LIST,
    title: 'Service Category List',
    component: ServiceCategoryList,
    permission: [PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.ServiceCategory,
  },
  {
    path: routes.SERVICE_CATEGORY_CREATE,
    title: 'Service Category Ticket',
    component: ServiceCategoryFormComponent,
    permission: [PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.ServiceCategory,
  },
  {
    path: routes.SERVICE_CATEGORY_EDIT,
    title: 'Service Category Ticket',
    component: ServiceCategoryFormComponent,
    permission: [PERMISSION_ROLES.superAdmin],
    screen_id: PERMISSION_ID.ServiceCategory,
  },

  // Service
  {
    path: routes.SERVICELIST,
    title: 'Services List',
    component: ServiceList,
    permission: [
      PERMISSION_ROLES.superAdmin,
      PERMISSION_ROLES.societyAdmin,
      PERMISSION_ROLES.vendor,
    ],
    screen_id: PERMISSION_ID.Service,
  },
  {
    path: routes.GET_OCCUPANTS_SERVICE,
    title: 'Services Occupants List',
    component: ServicesOccupantsList,
    permission: [
      PERMISSION_ROLES.superAdmin,
      PERMISSION_ROLES.societyAdmin,
      PERMISSION_ROLES.vendor,
    ],
    screen_id: PERMISSION_ID.Service,
  },
  {
    path: routes.CREATE_SERVICE,
    title: 'Services ',
    component: ServiceFormComponent,
    permission: [
      PERMISSION_ROLES.superAdmin,
      PERMISSION_ROLES.societyAdmin,
      PERMISSION_ROLES.vendor,
    ],
    screen_id: PERMISSION_ID.Service,
  },
  {
    path: routes.EDIT_SERVICE,
    title: 'Services ',
    component: ServiceFormComponent,
    permission: [
      PERMISSION_ROLES.superAdmin,
      PERMISSION_ROLES.societyAdmin,
      PERMISSION_ROLES.vendor,
    ],
    screen_id: PERMISSION_ID.Service,
  },

  // Vendor Booking

  {
    path: routes.BOOKING_LIST,
    title: 'Booking List',
    component: BookingList,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.vendor],
    screen_id: PERMISSION_ID.vendor,
  },
  {
    path: routes.BOOKING_CREATE,
    title: 'Booking',
    component: BookingFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.vendor],
    screen_id: PERMISSION_ID.vendor,
  },
  {
    path: routes.EDIT_BOOKING,
    title: 'Booking',
    component: BookingFormComponent,
    permission: [PERMISSION_ROLES.societyAdmin, PERMISSION_ROLES.vendor],
    screen_id: PERMISSION_ID.vendor,
  },

  // Panic Queries
  {
    path: routes.PANIC_QUERIES_LIST,
    title: 'Panic Queries List',
    component: PanicQueriesList,
    permission: [PERMISSION_ROLES.superAdmin, PERMISSION_ROLES.societyAdmin],
    screen_id: PERMISSION_ID.panicQueries,
  },
]

export default privateRoutes
